import { authorizedFetch } from "./requestBuilder.js";

export const getInvoices = async () => {
  try {
    return await authorizedFetch(
      `${process.env.REACT_APP_API_URL}/api/invoices`,
      {
        method: "GET",
      }
    );
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};

export const deleteInvoice = async (id) => {
  try {
    return await authorizedFetch(
      `${process.env.REACT_APP_API_URL}/api/invoices/${id}`,
      {
        method: "DELETE",
      }
    );
  } catch (error) {
    console.error("Error deleting invoice:", error);
    throw error;
  }
};

export const markPaid = async (id) => {
  try {
    return await authorizedFetch(
      `${process.env.REACT_APP_API_URL}/api/invoices/${id}/mark-paid`,
      {
        method: "POST",
      }
    );
  } catch (error) {
    console.error("Error updating invoice:", error);
    throw error;
  }
};

export const markUnpaid = async (id) => {
  try {
    return await authorizedFetch(
      `${process.env.REACT_APP_API_URL}/api/invoices/${id}/mark-unpaid`,
      {
        method: "POST",
      }
    );
  } catch (error) {
    console.error("Error updating invoice:", error);
    throw error;
  }
};

export const markCancelled = async (id) => {
  try {
    return await authorizedFetch(
      `${process.env.REACT_APP_API_URL}/api/invoices/${id}/cancel`,
      {
        method: "POST",
      }
    );
  } catch (error) {
    console.error("Error updating invoice:", error);
    throw error;
  }
};
